import { ActivitiesFormIngredientSupplier } from "./Activities.type";

export const isSupplierManagedBy = (
    supplier: Pick<ActivitiesFormIngredientSupplier, "managedBy">,
    organizationId: number | undefined,
): boolean => organizationId !== undefined && supplier.managedBy?.id === organizationId;
